// web/src/stores/interactiveCardStore.ts — Interactive card submission state.
import { create } from "zustand";
import { api } from "../lib/apiClient";
export const useInteractiveCardStore = create()((set) => ({
    submitting: false,
    lastError: null,
    submitCardResponse: async ({ cardId, cardType, values }) => {
        set({ submitting: true, lastError: null });
        try {
            const result = await api.submitCardResponse({
                card_id: cardId,
                card_type: cardType,
                values,
            });
            return result;
        }
        catch (err) {
            const msg = err instanceof Error ? err.message : String(err);
            set({ lastError: msg });
            throw err;
        }
        finally {
            set({ submitting: false });
        }
    },
}));
